import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface HomologyRegionMinLengthProps {
  homologyRegionMinLength: number | null;
  updateHomologyRegionMinLength: (length: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input to set the minimum length of the homology region in a Gibson assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.homologyRegionMinLength The minimum length, in base pairs, of the homology region.
 * @param {function} props.updateHomologyRegionMinLength A function that takes a new length and uses it to update state.
 * @constructor
 */
export function HomologyRegionMinLength(props: HomologyRegionMinLengthProps): JSX.Element {
  return (
    <InputWrapper
      id="homologyRegionMinLength"
      label="Min. length of homology/binding regions (bp)"
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.homologyRegionMinLength}
        required={true}
        onChange={(e) => {
          props.updateHomologyRegionMinLength(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
